const ProSanteManager = {
	config: {
		copyButtonSelector: '.mm-pro-sante-share-code-button',
		toastSelector: '#copy-toast',
		targetAttribute: 'data-copy-target',
		toastVisibleClass: 'mm-pro-sante-toast--visible',
		toastDuration: 2000,
		copiedClass: 'copied'
	},

	init() {
		const copyButton = document.querySelector(this.config.copyButtonSelector);
		if (copyButton) {
			copyButton.addEventListener('click', this.handleCopyClick.bind(this));
		}
	},

	handleCopyClick(event) {
		const targetId = event.currentTarget.getAttribute(this.config.targetAttribute);
		const textElement = document.querySelector(targetId);

		if (!textElement) return;

		const textToCopy = textElement.textContent.trim();
		navigator.clipboard.writeText(textToCopy)
			.then(() => this.showFeedback(event.currentTarget))
			.catch((err) => {
				if (window.log) {
					window.log('error', '📋 [PRO_SANTE]', 'Copy failed', { error: err.message });
				}
			});
	},

	showFeedback(copyButton) {
		const toast = document.querySelector(this.config.toastSelector);
		const icon = copyButton.querySelector('svg');

		if (toast) {
			toast.classList.add(this.config.toastVisibleClass);
			setTimeout(() => {
				toast.classList.remove(this.config.toastVisibleClass);
			}, this.config.toastDuration);
		}

		if (icon) {
			const originalClass = icon.getAttribute('class');
			icon.setAttribute('class', `${originalClass} ${this.config.copiedClass}`);
			setTimeout(() => {
				icon.setAttribute('class', originalClass);
			}, this.config.toastDuration);
		}
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => ProSanteManager.init());
} else {
	ProSanteManager.init();
}
